/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
export const isWeiBo = () => navigator.userAgent.match(/weibo/);

// 判断是否为qq和微信
export const isWeiXinAndQQ = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (isWeiXin() || isQQ()) {
    return true;
  }
  return false;
};

export const isWeiXin = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i)) {
    return true;
  }
  return false;
};

// 判断是否为qq和qq浏览器
export const isQQ = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/\sQQ/i)) {
    return true;
  }
  return false;
};
export const isIos = () => {
  const u = window.navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
};
export const isAndroid = () => {
  const u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
};


export const IsMobile = () => isIos() || isAndroid();
